<template>
  <b-modal id="enterprise-leader-modal" title="New Leader" hide-footer @shown="" @hidden="clearForm">
    <b-form @submit.prevent="submit">
      <b-form-group label="Name" label-class="form-control-label" label-for="name">
        <b-form-input v-model="form.name" required></b-form-input>
      </b-form-group>
      <b-form-group label="Email" label-class="form-control-label" label-for="email">
        <b-form-input type="email" v-model="form.email" required></b-form-input>
      </b-form-group>
      <div class="mb-3">
        <small>Passwords are automatically generated and sent to Leaders for security purposes. You can bypass this and create your own password below.</small>
      </div>
      <b-form-group label="Create Password" label-class="form-control-label" label-for="show_password" v-if="!form.show_password">
        <base-switch class="mr-1" v-model="form.show_password" required></base-switch>
      </b-form-group>
      <b-form-group label="Password" label-class="form-control-label" label-for="password" v-if="form.show_password">
        <b-form-input type="password" v-model="form.password"></b-form-input>
      </b-form-group>
      <b-form-group label="Send Leader Welcome Email" label-class="form-control-label" label-for="send_email">
        <base-switch class="mr-1" v-model="form.send_email" required></base-switch>
      </b-form-group>
      <b-button block type="submit" variant="success">Submit</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin.js';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  mixins: [errorsMixin],
  props: {
    userRoute: null,
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        send_email: true,
        password: '',
        show_password: false,
      }
    }
  },
  methods: {
    submit() {
      axios.post(this.userRoute + "/enterprises/" + this.$route.params.enterprise + "/leaders", {
        name: this.form.name,
        email: this.form.email,
        slug: this.$route.params.enterprise,
        send_email: this.form.send_email, 
        password: this.form.password
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$emit('getLeaders');
          this.$bvModal.hide('enterprise-leader-modal');
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    clearForm() {
      this.form = {
        name: '',
        email: '',
        send_email: true,
        password: '',
        show_password: false
      }
    }
  }
};
</script>